import { useState, useEffect, useContext } from 'react';
import Popup from 'reactjs-popup';
import config from '../../config'
import Select from 'react-select'
import {AssService} from '../../services/AssService'
import OtaService from '../../services/OtaService';
import AuthContext from '../../globalState/context/AuthProvider';

//import { Visibility } from '@tanstack/react-table'

/*--
    action[0] : pop state parameter
    action[2] : object type for OTA
    action[4] : object ids
    action[3] : function to call when Popup is closed
--*/
const MultiOTAPopUp = ({action,t}) => {
  
    const [openPopup,setOpenPopup] = useState (false);
    const [ids, setIds] = useState(action[2]);
    const [type, setType] = useState({})

    const context = useContext(AuthContext)
    const [objects, setObjects] = useState(new Map());
    const [firmwareIsForProduction, setFirmwareIsForProduction] = useState(true);
    const [selectOptions,setSelectOptions] = useState([]);
    const [selectedValue,setSelectedValue] = useState('');
    const [otaUrl,setOtaUrl] = useState('');
    const [progress,setProgress] = useState(0);
    const [toDo,setToDo] = useState([])

    
    useEffect(() => {
        ids.map((id,index)=>{

            AssService.getObject(id).then((result)=>{
                result.stateMsg = "Not started"
                setObjects(new Map(objects.set(result.realName,result)));
            });
        })
    }, [ids])

    

    useEffect(()=>{
        console.log(action[2]);
        setIds(action[2]);
    },[action[2]])

    useEffect(()=>{
        if(openPopup === false && action[0] === true) //ouverture initiale
        {

            console.log(action[1])
            setType({});

            OtaService.getFirmwaresByType(action[1][0].otaType).then(results => {
                console.log(results) 
                var options = []
                for (let result of results)
                {
                    options.push({label:result[4]+"-"+result[2],value:result[5]})
                }
                console.log(options)
                setSelectOptions(options)
            }).catch((error) => {
                console.error(error);
            });
        }
        setOpenPopup(action[0])
    },[action])

    function onOTA() {
       
        var body = {}
        setToDo(ids)

        try {
            if(action[1][0].ota == 'zigbee')
            {
                context.auth.otaWrkr.queueDevices(ids, otaUrl, context.auth.socket)
                context.auth.otaWrkr.setProgressCB(onProgress)
                //setProgressBar(1)
            }
            else if (action[1][0].ota == 'http')
            {
                //var criteria = {ids:[object.id]}
                //AssService.sendOtaUpgradeRequest(otaUrl,criteria)
            }
        } catch (e) {
          throw new Error(`API error:${e?.message}`)
        }    
    }

    function onProgress(progress)
    {
        console.log(progress)

        var name = progress.device?.data.realName

        if (progress.device?.data.realName != undefined)
        {
            var obj = objects.get(name)
            if (obj != undefined)
            {
                obj.stateMsg = progress.state
                if (progress.state == 'download in progress')
                    obj.stateMsg += " -> "+ progress.progress + " %"
                
                setObjects(new Map(objects.set(name,obj)));
            }
        }

        /*setProgress(progress)
        if (progress == 100)
        {
            setOpenPopup(false)
            action[3]()
        }*/
    }

    return (
        <Popup open={openPopup} closeOnDocumentClick modal className='commandPopUp'>
            <h5>{t('firmwares.popup.ota.title')}</h5>
            <div className='align-left'>
                {!firmwareIsForProduction&&<h6><box-icon type='solid' name='radiation'></box-icon>t('firmwares.popup.ota.warning')</h6>}
                <p>{t('firmwares.popup.ota.text')}</p>
                
                <p><b>{t('firmwares.popup.ota.type-label')}: </b>{}</p>
            </div>
            <Select 
                className="filter"
                options={selectOptions} 
                value={selectedValue}
                onChange={(e) => {
                  OtaService.getFirmware(e.value).then(data=>{
                    console.log(data)
                    setSelectedValue(data.label)
                    setOtaUrl(config.server()+'/repository/'+data.filename)
                  })
                }}
            />
            <div className='align-left'>
                
                <p><b>{t('firmwares.popup.ota.product-label')}: </b><>{[...objects].map((entry,index)=>{
                    return(<div key={entry[1].id}>{entry[1].userName} [ {entry[0]} ] : {entry[1].stateMsg}</div>)   
                })}</></p>
            
            </div>
            <button className="button" onClick={()=>{context.auth.otaWrkr.cancel();action[3]()}}>{t('objects.add.cancel')}</button>
            <button className="button" onClick={onOTA}>{t('objects.add.validate')}</button>
        </Popup>
    );
    
}
  
export default MultiOTAPopUp;